<template>
	<div class="map_obj">
		<div v-bind:id="this.map_div" class=" p-3  mt-4" style="height: 600px;display: none"></div>
	</div>
</template>

<script>
import {init_map} from '../../../../../../../../libs/map.js';
import {processPoints} from '../../../../../../../../libs/map.js';

import {MapLabel} from '../../../../../../../../libs/google/MapLabel.js';
//require("../../js/libs/google/MapLabel.js");

export default {
	name: "pai_map",

	data() {
		return {
			loading_unit: false,

			feature_collection: {
				"type": "FeatureCollection",
				"features": []
			},
			mapLabel : [],
			clusters : [],
			map_div: "map_div_user",
			map_g: null,
			map_feature: null,
		}
	},

	props : {

		"map_id" : {
			type : String,
			default : "map_div_user",
		},

		"data_1c": {
			type : Array
		},
		"data_panorama": {
			type : Array
		},
		owner : {
			type : String,
			default : "",
		},

		addon_fields: {
			type: Array,
		}
	},
	created() {

		this.map_div = this.map_id;

		EventBus.$on('map_loaded', res => {
			console.log("On Map load");
			if (res.name === this.map_div) {
				this.map_g = res.map;
				this.onMapLoaded(res.map);
			}
		});


	},

	mounted () {
		this.load_map();
	},

	methods : {
		onMapLoaded(event) {
			this.map = event.map;
			this.addPolygons();
		},

		load_map() {
			if (this.map_g == null) {
				init_map(this.map_div);
			}
			else {
				init_map(this.map_div);
			}
		},


		addPolygons() {
			this.feature_collection.features = [];



			try {

				let self = this;
				this.map_g.data.forEach(function(feature) {
					// filter...
					self.map_g.data.remove(feature);
				});

				this.geo_1c_uniq_poles.map(itm => {
					this.feature_collection.features.push(itm);
				})

				this.geo_panorama_polygons.map(itm => {
					this.feature_collection.features.push(itm);
				})

				this.map_feature = this.map_g.data.addGeoJson(this.feature_collection);
				this.addLabels();
				this.setStyles();
				this.fit_polygons();


			} catch (e) {
				console.log("err",e);
			}

		},

		addLabels() {
			this.map_feature.forEach(cluster => {
				let bounds = new google.maps.LatLngBounds();
				processPoints(cluster.getGeometry(), bounds.extend, bounds);

				this.clusters.push(cluster);
				let sub_type = cluster.getProperty("sub_type");
				let name =  cluster.getProperty('hintContent');
				let fontSize = 12;

				if(sub_type == 'pole') {
					name ="Поле " + cluster.getProperty('hintContent');
					fontSize = 15;
				}


				this.mapLabel.push( new MapLabel({
					text: name,
					position: bounds.getCenter(),
					map: this.map_g,
					fontSize: fontSize,
					strokeColor: '#ffffff',
					align: 'center'
				}));
			});

		},

		fit_polygons() {
			let bounds = new google.maps.LatLngBounds();

			this.map_feature.forEach(cluster => {
				let sub = cluster.getProperty("sub_type");
				if(sub != undefined && sub == 'pai') {
					processPoints(cluster.getGeometry(), bounds.extend, bounds);
				}
			});


			this.map_g.fitBounds(bounds);

		},

		setStyles() {
			try {
				this.map_g.data.setStyle(function (feature) {
					if (feature.getGeometry().getType() === 'Polygon') {
						let strokeColor = feature.getProperty('strokeColor');
						let line_height = feature.getProperty('strokeWidth');
						let fillColor = feature.getProperty('fillColor');
						return {
							strokeColor: strokeColor,
							strokeWeight: line_height,
							fillColor: fillColor
						};
					}
				});
			} catch (e) {
				console.log('style err');
			}
		},

		get_active_pai_1c(pai) {

		},

		check_is_current(pai) {
			try {
				if (pai.id == this.pai_memorandum_active.id) {
					return true;
				}
			}
			catch (e) {

			}
			return false;
		},


		get_current_val(type) {
			let res = null;
			this.addon_fields.map(itm => {
				if(itm.field_type === type) {
					res = itm;
				}
			});
			return res;
		},
	},

	computed : {

		geo_panorama_polygons() {
			let res = [];

			this.data_panorama.map(item => {
				if(item.hasOwnProperty("geo_json")) {
					let feature = {
						"id": item.params.kontragent,
						"type": "Feature",
						"geometry": item.geo_json,
						"properties" : {
							"sub_type" : "pai",
							"strokeWidth" : 1,
							"hintContent" : item.params.kontragent,
							"balloonContentHeader" :item.params.kontragent,
							"strokeColor" : "#454c43",
							"fillColor" : "#cb5ccf",
							"opacity" : 0.9
						}
					}
					if(this.check_is_current(item)) {
						feature.properties.fillColor = "#3CB371";
					}

					res.push(feature);
				}

			});

			return res;
		},

		geo_1c_uniq_poles () {
			let res_tmp = [];
			let res = [];
			let unique = [];
			let distinct = [];

			this.data_1c.map(item => {
				if(item.hasOwnProperty("poles_geo")) {
					let cur_geo = item.poles_geo;
					cur_geo.map(g => {
						res_tmp.push(g);
					})
				}
			})

			if(res_tmp.length > 0) {
				for( let i = 0; i < res_tmp.length; i++ ){
					if( !unique[res_tmp[i].name]){
						distinct.push(res_tmp[i]);
						unique[res_tmp[i].name] = 1;
					}
				}
			}

			if(distinct.length > 0) {
				distinct.map(g_ins => {
					if(g_ins.hasOwnProperty("feature")) {
						let inside_feature = g_ins.feature;

						inside_feature.fillRule = "nonZero";

						let feature = {
							"id": g_ins.name,
							"type": "Feature",
							"geometry": inside_feature,
							"properties" : {
								"strokeWidth" : 1,
								"sub_type" : "pole",
								"hintContent" : g_ins.name,
								"balloonContentHeader" : g_ins.name,
								"strokeColor" : "#c5281c",
								"fillColor" : "#e3d016",
								"opacity" : 0.9
							}
						}

						res.push(feature);
					}
				})
			}

			return res;
		},

		pai_memorandum_active() {
			let cur = null;

			try {
				this.data_panorama.map(item => {
					let kontragent = this.owner;
					if(kontragent != null && kontragent == item.params.kontragent) {
						cur = item;
					}

				});
			}
			catch (e) {
				console.log(e);
			}

			return cur;
		},

	},

}
</script>

<style scoped>

</style>
